import { render, staticRenderFns } from "./ProductHeaderWithImage.vue?vue&type=template&id=d42209b4&scoped=true"
import script from "./ProductHeaderWithImage.vue?vue&type=script&lang=js"
export * from "./ProductHeaderWithImage.vue?vue&type=script&lang=js"
import style0 from "./ProductHeaderWithImage.vue?vue&type=style&index=0&id=d42209b4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d42209b4",
  null
  
)

export default component.exports